import { eChannels, ePublishers, eTopics } from '../../utils/enums';

import DP from '../../facades/data-provider';
import Global from '../../global';
import actions from '../user/user-actions-creator';
import { publishTopicOnChannel } from '../../services/external-pub-sub/pub-sub-utils';

function sendKickToWrapper() {
  const channel = eChannels.session;
  const topic = eTopics.session.inactivityTimeout;
  const method = 'sendKickToWrapper()',
    data = null,
    headers = { publisher: ePublishers.sportclient };
  publishTopicOnChannel(topic, channel, method, data, headers);
}

export function login(userContext, initialSportClientToken) {
  return (dispatch, getState) => {
    dispatch(actions.startLogin());
    return DP.performLogin(userContext, initialSportClientToken)
      .then(loginResponse => {
        /*dispatch(recommendedActions.getBetsRecommendations());*/
        dispatch(actions.loginSuccess(loginResponse));

        publishTopicOnChannel(
          eTopics.session.clientInitSucceeded,
          eChannels.session,
          'hideLoader();',
          null,
          { publisher: ePublishers.sportclient }
        );

        DP.initSportProviderSocket({ dispatch, getState });
        window._kc.ticket = initialSportClientToken;
      })
      .catch(err => {
        dispatch(actions.loginFailed());
        Global.logger.log('err startLogin ', err);
      });
  };
}

export function extendSportClientSession(userContext) {
  return (dispatch, getState) => {
    const { useProdApis } = getState().appConfig;
    return DP.extendSession(userContext, useProdApis)
      .then(extendSessionResponse => {
        if (extendSessionResponse) {
          return dispatch(actions.extendSessionSuccess());
        } else {
          Global.logger.debug('[session] no response');
          sendKickToWrapper();
          return dispatch(actions.kickUser());
        }
      })
      .catch(err => {
        Global.logger.debug(
          `[session] user action catch -  ${err.message} ${err.code}`
        );
        sendKickToWrapper();
        return dispatch(actions.kickUser());
      });
  };
}

export function kickUser() {
  return dispatch => {
    return dispatch(actions.kickUser());
  };
}

export function changeOddsFormat(newOddsFormat) {
  return dispatch => {
    return dispatch(actions.changeOddsFormat(newOddsFormat));
  };
}

export function updateUserContext(newUserDetails) {
  return actions.updateUserContext(newUserDetails);
}

export function setUserToken(token) {
  return actions.setUserToken(token);
}
